// src/pages/NivelTestReview.js
import React, { useEffect, useMemo, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useFuncion } from "../context/FuncionContext";
import LoadingSpinner from "../components/LoadingSpinner";

const CSS = `
:root{
  --ntr-bg:#f8fafc;
  --ntr-card:#ffffff;
  --ntr-border:#e5e7eb;
  --ntr-border-soft:#eef2f7;
  --ntr-text:#111827;
  --ntr-muted:#6b7280;
  --ntr-primary:#1d4ed8;
  --ntr-primary-soft:#eff6ff;
  --ntr-ok:#065f46;
  --ntr-ok-bg:#ecfdf5;
  --ntr-ok-border:#a7f3d0;
  --ntr-bad:#991b1b;
  --ntr-bad-bg:#fef2f2;
  --ntr-bad-border:#fecaca;
  --ntr-na:#374151;
  --ntr-na-bg:#f3f4f6;
  --ntr-na-border:#e5e7eb;
  --ntr-shadow:0 10px 30px rgba(0,0,0,.06);
}

*,
*::before,
*::after{
  box-sizing:border-box;
}

.ntr-shell{
  width:100%;
  max-width:1120px;
  margin:0 auto;
  padding:18px;
}

.ntr-head{
  display:flex;
  align-items:flex-start;
  justify-content:space-between;
  gap:14px;
  flex-wrap:wrap;
}

.ntr-title{
  display:flex;
  flex-direction:column;
  gap:4px;
  min-width:0;
  flex:1 1 420px;
}

.ntr-title h1{
  margin:0;
  font-size:clamp(1.25rem, 1rem + 1vw, 1.7rem);
  line-height:1.2;
  color:var(--ntr-text);
  word-break:break-word;
}

.ntr-title p{
  margin:0;
  color:var(--ntr-muted);
  font-weight:600;
  line-height:1.45;
  word-break:break-word;
}

.ntr-actions{
  display:flex;
  gap:10px;
  align-items:center;
  flex:0 0 auto;
}

.ntr-btn{
  border:1px solid var(--ntr-border);
  background:#fff;
  color:var(--ntr-text);
  padding:10px 14px;
  border-radius:12px;
  font-weight:800;
  cursor:pointer;
  transition:transform .18s ease, box-shadow .18s ease, border-color .18s ease;
  white-space:nowrap;
}

.ntr-btn:hover{
  transform:translateY(-1px);
  box-shadow:0 10px 24px rgba(0,0,0,.06);
  border-color:#d1d5db;
}

.ntr-card{
  margin-top:14px;
  background:var(--ntr-card);
  border:1px solid var(--ntr-border);
  border-radius:18px;
  box-shadow:var(--ntr-shadow);
  overflow:hidden;
  min-width:0;
}

.ntr-tabs{
  display:flex;
  gap:8px;
  padding:12px;
  border-bottom:1px solid var(--ntr-border-soft);
  overflow-x:auto;
  overflow-y:hidden;
  -webkit-overflow-scrolling:touch;
  scrollbar-width:thin;
  scroll-padding:12px;
}

.ntr-tab{
  display:inline-flex;
  align-items:center;
  gap:8px;
  padding:10px 14px;
  border-radius:999px;
  border:1px solid var(--ntr-border);
  background:#fff;
  font-weight:900;
  white-space:nowrap;
  cursor:pointer;
  transition:transform .18s ease, box-shadow .18s ease, border-color .18s ease, background .18s ease;
  flex:0 0 auto;
}

.ntr-tab:hover{
  transform:translateY(-1px);
}

.ntr-tab.active{
  border-color:var(--ntr-primary);
  background:var(--ntr-primary-soft);
  box-shadow:0 10px 22px rgba(37,99,235,.12);
}

.ntr-pill{
  font-size:12px;
  line-height:1.1;
  padding:4px 8px;
  border-radius:999px;
  border:1px solid var(--ntr-border);
  font-weight:900;
  white-space:nowrap;
  flex:0 0 auto;
}

.ntr-pill.ok{
  background:var(--ntr-ok-bg);
  border-color:var(--ntr-ok-border);
  color:var(--ntr-ok);
}

.ntr-pill.bad{
  background:var(--ntr-bad-bg);
  border-color:var(--ntr-bad-border);
  color:var(--ntr-bad);
}

.ntr-body{
  padding:14px;
  display:flex;
  flex-direction:column;
  gap:14px;
  min-width:0;
}

.ntr-kpis{
  display:grid;
  grid-template-columns:repeat(4, minmax(0,1fr));
  gap:10px;
}

.ntr-kpi{
  border:1px solid var(--ntr-border-soft);
  border-radius:14px;
  padding:12px;
  background:linear-gradient(180deg,#fff,#fbfdff);
  min-width:0;
}

.ntr-kpi .k{
  font-size:12px;
  color:var(--ntr-muted);
  font-weight:900;
  text-transform:uppercase;
  letter-spacing:.6px;
  word-break:break-word;
}

.ntr-kpi .v{
  margin-top:6px;
  font-size:clamp(1rem, .85rem + .8vw, 1.25rem);
  font-weight:1000;
  color:var(--ntr-text);
  line-height:1.25;
  overflow-wrap:anywhere;
  word-break:break-word;
}

.ntr-list{
  display:flex;
  flex-direction:column;
  gap:12px;
}

.ntr-q{
  border:1px solid var(--ntr-border-soft);
  border-radius:16px;
  padding:14px;
  background:#fff;
  min-width:0;
}

.ntr-qhead{
  display:flex;
  align-items:flex-start;
  justify-content:space-between;
  gap:10px;
  min-width:0;
}

.ntr-qtitle{
  font-weight:950;
  color:var(--ntr-text);
  line-height:1.5;
  flex:1 1 auto;
  min-width:0;
  overflow-wrap:anywhere;
  word-break:break-word;
  white-space:pre-wrap;
}

.ntr-badge{
  font-size:12px;
  padding:4px 10px;
  border-radius:999px;
  font-weight:950;
  border:1px solid var(--ntr-border);
  white-space:nowrap;
  flex:0 0 auto;
}

.ntr-badge.ok{
  background:var(--ntr-ok-bg);
  border-color:var(--ntr-ok-border);
  color:var(--ntr-ok);
}

.ntr-badge.bad{
  background:var(--ntr-bad-bg);
  border-color:var(--ntr-bad-border);
  color:var(--ntr-bad);
}

.ntr-badge.na{
  background:var(--ntr-na-bg);
  border-color:var(--ntr-na-border);
  color:var(--ntr-na);
}

.ntr-qmeta{
  margin-top:10px;
  display:grid;
  grid-template-columns:1fr 1fr;
  gap:10px;
  min-width:0;
}

.ntr-box{
  border:1px solid var(--ntr-border-soft);
  border-radius:14px;
  padding:12px;
  background:#fbfbfb;
  min-width:0;
}

.ntr-box .k{
  font-size:12px;
  color:var(--ntr-muted);
  font-weight:900;
  margin-bottom:6px;
  text-transform:uppercase;
  letter-spacing:.4px;
  overflow-wrap:anywhere;
}

.ntr-box .v{
  font-weight:800;
  color:var(--ntr-text);
  white-space:pre-wrap;
  line-height:1.5;
  overflow-wrap:anywhere;
  word-break:break-word;
}

.ntr-empty,
.ntr-error{
  font-weight:900;
  line-height:1.5;
  overflow-wrap:anywhere;
  word-break:break-word;
}

.ntr-error{
  color:var(--ntr-bad);
}

@media (max-width: 980px){
  .ntr-kpis{
    grid-template-columns:repeat(2, minmax(0,1fr));
  }
}

@media (max-width: 860px){
  .ntr-shell{
    padding:14px;
  }

  .ntr-head{
    flex-direction:column;
    align-items:stretch;
  }

  .ntr-actions{
    width:100%;
  }

  .ntr-btn{
    width:100%;
    justify-content:center;
  }

  .ntr-qmeta{
    grid-template-columns:1fr;
  }
}

@media (max-width: 640px){
  .ntr-shell{
    padding:12px;
  }

  .ntr-card{
    border-radius:16px;
  }

  .ntr-body{
    padding:12px;
  }

  .ntr-tabs{
    padding:10px;
    gap:6px;
  }

  .ntr-tab{
    padding:9px 12px;
    font-size:14px;
  }

  .ntr-pill{
    font-size:11px;
    padding:4px 7px;
  }

  .ntr-kpis{
    grid-template-columns:1fr;
  }

  .ntr-q{
    padding:12px;
    border-radius:14px;
  }

  .ntr-qhead{
    flex-direction:column;
    align-items:flex-start;
  }

  .ntr-qtitle{
    font-size:15px;
  }

  .ntr-box{
    padding:10px;
  }
}

@media (max-width: 420px){
  .ntr-title h1{
    font-size:1.15rem;
  }

  .ntr-title p{
    font-size:.92rem;
  }

  .ntr-tab{
    max-width:100%;
  }
}
`;

function fmtDuration(seg) {
  const s = Math.max(0, Number(seg || 0));
  const mm = Math.floor(s / 60);
  const ss = s % 60;
  if (mm <= 0) return `${ss}s`;
  return `${mm}m ${String(ss).padStart(2, "0")}s`;
}

function normalizeOptions(opciones) {
  if (!opciones) return [];
  const raw = Array.isArray(opciones)
    ? opciones
    : (Array.isArray(opciones?.opciones) ? opciones.opciones : []);

  return raw
    .map((o, idx) => {
      if (o == null) return null;
      if (typeof o === "string") return { id: idx + 1, texto: o };
      if (typeof o === "number") return { id: o, texto: String(o) };
      const id = o.id ?? o.value ?? (idx + 1);
      const texto = o.texto ?? o.label ?? o.nombre ?? o.text ?? String(id);
      return { id, texto };
    })
    .filter(Boolean);
}

function mapOptionIdsToText(ids, opciones) {
  const opts = normalizeOptions(opciones);
  const byId = new Map(opts.map((o) => [String(o.id), o.texto]));
  return (Array.isArray(ids) ? ids : [ids])
    .filter((v) => v !== null && v !== undefined)
    .map((v) => byId.get(String(v)) ?? String(v))
    .join(", ");
}

function fmtVF(v) {
  if (v === true || v === "true" || v === "V" || v === "verdadero") return "Verdadero";
  if (v === false || v === "false" || v === "F" || v === "falso") return "Falso";
  return String(v);
}

function answerToText(ans, q) {
  if (ans === null || ans === undefined) return "";

  if (typeof ans === "string") return ans;
  if (typeof ans === "number") return String(ans);
  if (typeof ans === "boolean") {
    if (String(q?.tipo).toLowerCase() === "verdadero_falso") return fmtVF(ans);
    return ans ? "Sí" : "No";
  }

  if (Array.isArray(ans)) {
    const allNumOrStr = ans.every((x) => typeof x === "number" || typeof x === "string");
    if (String(q?.tipo).toLowerCase() === "seleccion_multiple" && allNumOrStr) {
      return mapOptionIdsToText(ans, q?.opciones);
    }
    if (allNumOrStr) return ans.map(String).join(", ");
    return ans
      .map((o) => {
        if (o == null) return "";
        if (typeof o !== "object") return String(o);
        const a = o.izq ?? o.left ?? o.a ?? o.pregunta ?? o.clave ?? o.key;
        const b = o.der ?? o.right ?? o.b ?? o.respuesta ?? o.valor ?? o.value;
        if (a != null && b != null) return `${String(a)} → ${String(b)}`;
        return JSON.stringify(o);
      })
      .filter(Boolean)
      .join("\n");
  }

  if (typeof ans === "object") {
    const tipo = String(q?.tipo || "").toLowerCase();

    if (tipo === "seleccion_multiple") {
      if (Array.isArray(ans.correctas)) return mapOptionIdsToText(ans.correctas, q?.opciones);
      if (Array.isArray(ans.seleccionadas)) return mapOptionIdsToText(ans.seleccionadas, q?.opciones);
      if (Array.isArray(ans.respuestas)) return mapOptionIdsToText(ans.respuestas, q?.opciones);
      if (ans.id != null) return mapOptionIdsToText(ans.id, q?.opciones);
    }

    if (tipo === "verdadero_falso") {
      const v = ans.valor ?? ans.respuesta ?? ans.answer ?? ans.value;
      if (v !== undefined) return fmtVF(v);
    }

    if (tipo === "respuesta_corta" || tipo === "completar") {
      const t = ans.texto ?? ans.respuesta ?? ans.answer ?? ans.value;
      if (t !== undefined) return String(t);
    }

    if (tipo === "ordenamiento") {
      const ord = ans.orden ?? ans.items ?? ans.secuencia;
      if (Array.isArray(ord)) return ord.map(String).join(" → ");
    }

    if (tipo === "emparejamiento") {
      const pares = ans.pares ?? ans.matches ?? ans.emparejamientos;
      if (Array.isArray(pares)) {
        return pares
          .map((p) => {
            const a = p?.izq ?? p?.left ?? p?.a;
            const b = p?.der ?? p?.right ?? p?.b;
            if (a != null && b != null) return `${String(a)} → ${String(b)}`;
            return p ? JSON.stringify(p) : "";
          })
          .filter(Boolean)
          .join("\n");
      }
    }

    if (ans.texto != null) return String(ans.texto);
    if (ans.respuesta != null) return String(ans.respuesta);
    if (ans.value != null) return String(ans.value);
    if (ans.label != null) return String(ans.label);

    try {
      return JSON.stringify(ans, null, 2);
    } catch (_) {
      return String(ans);
    }
  }

  return String(ans);
}

export default function NivelTestReview() {
  const { nivelId, codigoCurso } = useParams();
  const navigate = useNavigate();
  const { getLevelTestReview } = useFuncion();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [activeAttemptId, setActiveAttemptId] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    let alive = true;

    (async () => {
      setLoading(true);
      setErr("");

      try {
        const res = await getLevelTestReview(Number(nivelId));
        if (!alive) return;

        setData(res);

        const intentos = Array.isArray(res?.intentos) ? res.intentos : [];

        const approved = intentos
          .filter(
            (a) =>
              a?.aprobado === true ||
              String(a?.estado || "").toLowerCase() === "approved" ||
              String(a?.estado || "").toLowerCase() === "aprobado"
          )
          .sort((a, b) => {
            const na = Number(a?.numero_intento ?? -1);
            const nb = Number(b?.numero_intento ?? -1);
            if (nb !== na) return nb - na;
            const fa = String(a?.fecha_finalizacion || a?.fecha_inicio || "");
            const fb = String(b?.fecha_finalizacion || b?.fecha_inicio || "");
            return fb.localeCompare(fa);
          });

        const finished = intentos
          .filter(
            (a) =>
              !!a?.fecha_finalizacion ||
              ["completed", "finalizado", "finished", "done", "terminated", "terminado"].includes(
                String(a?.estado || "").toLowerCase()
              )
          )
          .sort((a, b) => {
            const na = Number(a?.numero_intento ?? -1);
            const nb = Number(b?.numero_intento ?? -1);
            if (nb !== na) return nb - na;
            const fa = String(a?.fecha_finalizacion || a?.fecha_inicio || "");
            const fb = String(b?.fecha_finalizacion || b?.fecha_inicio || "");
            return fb.localeCompare(fa);
          });

        const preferredId = approved?.[0]?.id ?? finished?.[0]?.id ?? intentos?.[0]?.id ?? null;
        setActiveAttemptId(preferredId);
      } catch (e) {
        console.error(e);
        if (!alive) return;
        setErr("No se pudo cargar la revisión del test.");
      } finally {
        if (alive) setLoading(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, [nivelId, getLevelTestReview]);

  useEffect(() => {
    const id = "nivel-test-review-css";
    if (document.getElementById(id)) return;

    const style = document.createElement("style");
    style.id = id;
    style.innerHTML = CSS;
    document.head.appendChild(style);
  }, []);

  const attempts = data?.intentos || [];

  const activeAttempt = useMemo(() => {
    if (!attempts.length) return null;
    return attempts.find((a) => String(a.id) === String(activeAttemptId)) || attempts[0];
  }, [attempts, activeAttemptId]);

  const kpis = useMemo(() => {
    const a = activeAttempt;
    if (!a) return null;

    const total = a?.stats?.total_preguntas ?? a?.preguntas?.length ?? 0;
    const correctas = a?.stats?.correctas ?? 0;
    const pct = Number(a?.porcentaje_obtenido ?? 0);

    return {
      pct: `${pct.toFixed(0)}%`,
      aprobado: a?.aprobado ? "Sí" : "No",
      score: `${correctas}/${total}`,
      dur: fmtDuration(a?.duracion_seg ?? a?.tiempo_empleado_segundos ?? 0),
    };
  }, [activeAttempt]);

  if (loading) {
    return (
      <div className="ntr-shell">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div className="ntr-shell">
      <div className="ntr-head">
        <div className="ntr-title">
          <h1>Revisión del test de nivel</h1>
          <p>Revisa tus intentos, estadísticas y respuestas.</p>
        </div>

        <div className="ntr-actions">
          <button
            className="ntr-btn"
            type="button"
            onClick={() => navigate(`/curso/${codigoCurso}`)}
          >
            Volver al curso
          </button>
        </div>
      </div>

      {err ? (
        <div className="ntr-card">
          <div className="ntr-body">
            <div className="ntr-error">{err}</div>
          </div>
        </div>
      ) : null}

      {!err && attempts.length === 0 ? (
        <div className="ntr-card">
          <div className="ntr-body">
            <div className="ntr-empty">Aún no tienes intentos registrados para este test.</div>
          </div>
        </div>
      ) : null}

      {!err && attempts.length > 0 ? (
        <div className="ntr-card">
          <div className="ntr-tabs">
            {attempts.map((a) => {
              const ok = !!a.aprobado;
              return (
                <button
                  key={a.id}
                  type="button"
                  className={`ntr-tab ${String(a.id) === String(activeAttemptId) ? "active" : ""}`}
                  onClick={() => setActiveAttemptId(a.id)}
                >
                  <span>Intento {a.numero_intento ?? "—"}</span>
                  <span className={`ntr-pill ${ok ? "ok" : "bad"}`}>
                    {ok ? "Aprobado" : "No aprobado"}
                  </span>
                </button>
              );
            })}
          </div>

          <div className="ntr-body">
            {activeAttempt && kpis ? (
              <>
                <div className="ntr-kpis">
                  <div className="ntr-kpi">
                    <div className="k">Porcentaje</div>
                    <div className="v">{kpis.pct}</div>
                  </div>
                  <div className="ntr-kpi">
                    <div className="k">Aprobado</div>
                    <div className="v">{kpis.aprobado}</div>
                  </div>
                  <div className="ntr-kpi">
                    <div className="k">Correctas</div>
                    <div className="v">{kpis.score}</div>
                  </div>
                  <div className="ntr-kpi">
                    <div className="k">Duración</div>
                    <div className="v">{kpis.dur}</div>
                  </div>
                </div>

                <div className="ntr-list">
                  {(activeAttempt.preguntas || []).map((q, idx) => {
                    const correcto = q.correcto;
                    const badgeClass = correcto === true ? "ok" : correcto === false ? "bad" : "na";
                    const badgeText =
                      correcto === true
                        ? "Correcta"
                        : correcto === false
                          ? "Incorrecta"
                          : "Sin calificar";

                    return (
                      <div className="ntr-q" key={q.uid || `${idx}`}>
                        <div className="ntr-qhead">
                          <div className="ntr-qtitle">
                            {idx + 1}. {q.enunciado || "Pregunta"}
                          </div>
                          {/* Si luego quieres volver a mostrarla, ya queda lista */}
                          {/* <span className={`ntr-badge ${badgeClass}`}>{badgeText}</span> */}
                        </div>

                        <div className="ntr-qmeta">
                          <div className="ntr-box">
                            <div className="k">Tu respuesta</div>
                            <div className="v">{answerToText(q.respuesta_usuario, q) || "—"}</div>
                          </div>

                          <div className="ntr-box">
                            <div className="k">Respuesta correcta</div>
                            <div className="v">{answerToText(q.correcta, q) || "—"}</div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            ) : null}
          </div>
        </div>
      ) : null}
    </div>
  );
}